/*
Suresh Peddavoora 10/28/2022 3075154998 Added Class Name for Text Fields and Buttons
Lalitha           11/9/2022  3075154998 Rename Button Cancel to Reset
*/

import React, {useContext} from 'react';
import {Formik} from 'formik';
import {Button, Grid, TextField, FormHelperText} from '@material-ui/core';

import * as Yup from 'yup';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';

const ConditionForm = ({setFilterData, filterData, setOpen, rowData, isEdit, setIsEdit}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  const initialValues = {
    filterCode: rowData?.filterCode ? rowData?.filterCode : '',
    description: rowData?.description ? rowData?.description : '',
  };

  const handleSubmit = (values) => {
    values.filterCode = values.filterCode.toUpperCase();
    const data = {...values};
    const copyData = [...filterData];

    if (!isEdit) {
      copyData.push({...data, tableData: {checked: true}});
      setFilterData(copyData);
      setOpen(false);
    } else {
      const updatedData = copyData.map((each) => {
        if (each.seqNo === rowData?.seqNo) {
          return {
            ...each,
            filterCode: data.filterCode,
            description: data.description,
          };
        } else {
          return {...each};
        }
      });
      setFilterData(updatedData);
      setOpen(false);
      setIsEdit(false);
    }
  };

  const schema = Yup.object().shape({
    description: Yup.string().required('Description is required'),
    filterCode: Yup.string().required('Filter Code is required'),
  });
  return (
    <div className={classes.dialoguecardStyles}>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        validationSchema={schema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            touched,
            errors,
            resetForm,
            handleChange,
            handleSubmit,
            handleReset,
            handleBlur,
          } = props;
          return (
            <div>
              <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                <div className="global-field-textfields">
                  <Grid container spacing={2}>
                    <Grid item xs={6} xl={6} md={6} sm={6} className="pl-md-1 form-group">
                      <TextField
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        margin="dense"
                        variant="outlined"
                        placeholder={`Enter Filter Code`}
                        label="Filter Code"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="filterCode"
                        value={values.filterCode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        required
                        touched={touched.filterCode}
                        error={Boolean(touched.filterCode && errors.filterCode)}
                      />
                      <FormHelperText style={{color: 'red'}}>
                        {touched.filterCode && errors.filterCode}
                      </FormHelperText>
                    </Grid>

                    <Grid item xs={6} xl={6} md={6} sm={6} className="pl-md-1 form-group">
                      <TextField
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        margin="dense"
                        variant="outlined"
                        placeholder={`Enter Description`}
                        label="Description"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="description"
                        value={values.description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        required
                        touched={touched.description}
                        error={Boolean(touched.description && errors.description)}
                      />
                      <FormHelperText style={{color: 'red'}}>
                        {touched.description && errors.description}
                      </FormHelperText>
                    </Grid>
                  </Grid>
                </div>
                <div className="text-center">
                  <div className="row justify-content-center mb-1">
                    <Button
                      type="button"
                      onClick={() => resetForm()}
                      variant="outlined"
                      className={`reset-btn mx-1 ${classes.buttonRoot}`}
                    >
                      Reset
                    </Button>
                    <Button
                      type="submit"
                      variant="outlined"
                      className={`search-btn mx-1 ${classes.buttonRoot}`}
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          );
        }}
      </Formik>
    </div>
  );
};

export default ConditionForm;
